export const CAMPAIGN_REACHOUT_INFLUENCER_KEY = ["campaign-reach-out"];
